import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UpdatableObjectFilterState, UpdatableObjectState } from "store/api/updatableObjects/types";
import { request as updatableObjectsRequest } from "store/api/updatableObjects/updatableObjectsActions";
import { UpdatableObjectFilterType } from "store/api/updatableObjects/helpers";

interface RootState {
  updatableObjects: UpdatableObjectState;
}

function useUpdatableObjects(startRequest = true,filterType: UpdatableObjectFilterType = "splitTunneling") {
  const dispatch = useDispatch();
  const updatableObjectsFilter = useSelector(
    (state: RootState) => state.updatableObjects[filterType]
  );

  useEffect(() => {
    if (!startRequest) return;
    dispatch(updatableObjectsRequest(filterType));
  }, [dispatch,startRequest, filterType]);

  return [
    updatableObjectsFilter.loading,
    updatableObjectsFilter.loaded,
    updatableObjectsFilter.data,
    updatableObjectsFilter.error,
  ] as [
    UpdatableObjectFilterState["loading"],
    UpdatableObjectFilterState["loaded"],
    UpdatableObjectFilterState["data"],
    UpdatableObjectFilterState["error"]
  ];
}

export default useUpdatableObjects;
